module.exports = __webpack_public_path__ + "static/img/sled-base-with-frame.2e27aa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/nps/sled-base-with-frame.jpg
// module id = 746
// module chunks = 0